module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-cell-box weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link, 'weui-cell_access': _vm.isLink || !!_vm.link, 'vux-cell-no-border-intent': !_vm.borderIntent
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4693a134"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/cell-box/index.vue
// module id = 499
// module chunks = 4